import { DeleteRoleComponent } from "./components/delete-role.component";
import { PermissionsCtrl } from "./controllers/permissions";
import { RolesCtrl } from "./controllers/roles";
import { RoleService } from "./role-service";
import { CurrentUserRolesActions } from "./redux/current-user-roles-actions";
import { downgradeComponent } from "@angular/upgrade/static";
import { RoleEditorComponent } from "@webapp/roles/role-editor/role-editor.component";
import { RolesActions } from "./redux/roles-actions";

const mod = angular.module("roles", []);

mod.controller("RolesCtrl", RolesCtrl);
mod.controller("PermissionsCtrl", PermissionsCtrl);
mod.component("deleteRole", DeleteRoleComponent);

mod.service("RoleService", RoleService);
mod.service("CurrentUserRolesActions", CurrentUserRolesActions);
mod.service("RolesActions", RolesActions);

mod.directive("roleEditor", downgradeComponent({ component: RoleEditorComponent }));

export default mod.name;
